/*
  FSMC section ids
 */

export default [
  'question01',
  'question02',
  'question03',
  'question04',
  'question05',
  'question06',
  'question07',
  'question08',
  'question09',
  'question10',
  'question11',
  'question12',
  'question13',
  'question14',
  'question15',
  'question16',
  'question17',
  'question18',
  'question19',
  'question20',
];

export const historySections = {
  physical: [
    'question02',
    'question03',
    'question05',
    'question06',
    'question09',
    'question10',
    'question12',
    'question14',
    'question16',
    'question19',
  ],
  mental: [
    'question01',
    'question04',
    'question07',
    'question08',
    'question11',
    'question13',
    'question15',
    'question17',
    'question18',
    'question20',
  ],
};
